import {
  IPeerGroupsProps,
  getPeerGroupData,
  IFilter,
} from "app/components/visualizations/PeerGroups/lib/http";
import * as React from "react";
import { Row, Col, Panel } from "react-bootstrap";
import { Visualization15 } from "app/components/visualizations/PeerGroups/OperatingExpenses/Visualization15";
import { Visualization13 } from "app/components/visualizations/PeerGroups/OperatingExpenses/Visualization13";
import { Visualization14 } from "app/components/visualizations/PeerGroups/OperatingExpenses/Visualization14";
import { TabHeader } from "app/components/tabs/header";
import TabFootnote from "app/components/tabs/TabFootnote";

interface IOperatingExpenseState {
  data: any[];
  currentPeerGroup: any[];
  filters: IFilter;
}

export class OperatingExpense extends React.Component<
  IPeerGroupsProps,
  IOperatingExpenseState
> {
  state: IOperatingExpenseState = {
    data: [],
    currentPeerGroup: [],
    filters: { assetLevel: 0 },
  };

  componentDidMount() {
    this.pullData(this.props.filters);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel) {
      this.setState({ filters: this.props.filters }, () => {
        this.pullData(this.props.filters);
      });
    }
  }

  pullData(filters: IFilter) {
    const requestBody = {
      action: "getOperatingExpenses",
      request: { assetLevel: filters.assetLevel },
    };
    getPeerGroupData(requestBody).then((response: any[]) => {
      const currentPeerGroup = response.find(
        (dataPoint) => dataPoint.filterId === this.props.filters.assetLevel
      );
      this.setState({ data: response, currentPeerGroup });
    });
  }

  render() {
    const { currentPeerGroup, data } = this.state;
    return (
      <div>
        <TabHeader filters={this.props.filters} label="Operating Expenses" />
        <Row style={{ marginTop: "1.0rem" }}>
          <Col sm={12} md={5}>
            <Visualization15 data={data} filters={this.props.filters} />
          </Col>
          <Col sm={12} md={7}>
            <Panel>
              <div className="panel-body">
                <Row>
                  <Col sm={12}>
                    <p>{currentPeerGroup && currentPeerGroup["OpEx_T_B_OpExIntro1"]}</p>
                  </Col>
                </Row>
                <Row className="text-center">
                  <Col sm={12} md={6}>
                    <h5>Grants</h5>
                    <h6 className="text-primary">
                      {currentPeerGroup && currentPeerGroup["InvOver_T_B_Grants"]}
                    </h6>
                    <p>{currentPeerGroup && currentPeerGroup["OpEx_T_B_OpExIntro4"]}</p>
                  </Col>
                  <Col sm={12} md={6}>
                    <h5>Operating Expenses</h5>
                    <h6 className="text-primary">
                      {currentPeerGroup && currentPeerGroup["InvOver_T_B_Opex"]}
                    </h6>
                    <p>{currentPeerGroup && currentPeerGroup["OpEx_T_B_OpExIntro5"]}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <p>{currentPeerGroup && currentPeerGroup["OpEx_T_B_OpExIntro2"]}</p>
                  </Col>
                  <Col sm={12}>
                    <p>{currentPeerGroup && currentPeerGroup["OpEx_T_B_OpExIntro3"]}</p>
                  </Col>
                </Row>
              </div>
            </Panel>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={3}>
            <Panel>
              <div className="panel-body">
                <Row>
                  <Col sm={12}>
                    <p>{currentPeerGroup && currentPeerGroup["OpEx_T_B_OpExPlaceholder3"]}</p>
                    <p>{currentPeerGroup && currentPeerGroup["OpEx_T_B_OpExPlaceholder1"]}</p>
                  </Col>
                </Row>
              </div>
            </Panel>
          </Col>
          <Col sm={12} md={9}>
            <Visualization14 data={data} filters={this.props.filters} />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <TabFootnote>
              <p>&#42;{currentPeerGroup && currentPeerGroup["OpEx_T_B_Disclaimer3"]}</p>
            </TabFootnote>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={9}>
            <Visualization13 data={data} filters={this.props.filters} />
          </Col>
          <Col sm={12} md={3}>
            <Panel>
              <div className="panel-body">
                <Row>
                  <Col sm={12}>
                    <p>{currentPeerGroup && currentPeerGroup["OpEx_T_B_HowtoRead13"]}</p>
                    <p>{currentPeerGroup && currentPeerGroup["OpEx_T_B_OpExPlaceholder2"]}</p>
                  </Col>
                </Row>
              </div>
            </Panel>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <TabFootnote>
              <p>{currentPeerGroup && currentPeerGroup["OpEx_T_B_Disclaimer1"]}</p>
              <p>{currentPeerGroup && currentPeerGroup["OpEx_T_B_Disclaimer2"]}</p>
            </TabFootnote>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/PeerGroups/tabs/OperatingExpense.tsx